export default __webpack_public_path__ + "static/media/icons8-photo.c5dad7d9.svg";